export default "__VITE_ASSET__CKpZbjrQ__"